<template>
  <div
    v-if="options"
    v-loading="isLoading"
    :class="['grid-filter multi-select', options.classes, {'is-clear': isClear}]"
    :style="options.styles">
    <el-form-item
      :label="fieldLabel"
      class="material-style"
    >
      <el-select
        v-model="model"
        filterable
        :placeholder="options.placeholder"
        :loading="isLoading"
        :size="options.size"
        @input.native.prevent.stop="handlerInput"
        @change="debounceHandleChange"
        @clear="handleReset"
        :popper-class="`filter-multiselect-dropdown ${(source && source.length > 1) ? 'is-select-all' : ''}`"
        clearable collapse-tags multiple>
        <el-option
          v-for="item in source"
          :key="item[options.option.value]"
          :label="item[options.option.label]"
          :value="item[options.option.value]">
        <span
          v-if="typeof options.option.template === 'function'"
          v-html="options.option.template(item)"/>
          <span v-else>
          <div class="option-check-box-select">
            <span :class="['el-checkbox__input', {'is-checked': isSelectedOption(item[options.option.value])}]">
              <span class="el-checkbox__inner"></span>
            </span>
            <span class="el-checkbox__label">{{item[options.option.label]}}</span>
          </div>
        </span>
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import mixins from '../mixins'
import { api } from '@/services/api'

export default {
  name: 'FilterMultiSelectAutoComplete',
  mixins: [mixins],
  props: {
    config: { type: Object },
    place: { type: String, default: 'column' }
  },
  data () {
    return {
      model: [],
      source: [],
      debounceHandleChange: null,
      debounceHandlerFilter: null
    }
  },
  computed: {
    isClear () {
      return this.model.length === 0
    },
    fieldLabel () {
      return this.checkJsTemplate(this.config.label)
    }
  },
  created () {
    this.debounceHandleChange = this.$_.debounce(this.handleChange, 100)
    this.debounceHandlerFilter = this.$_.debounce(this.createSource, 300)
  },
  methods: {
    isSelectedOption (value) {
      return !!this.model.find(modelValue => {
        return value === modelValue
      })
    },
    MODEL () {
      return {
        /* TODO:
            dataSource:
              Массив || Строка-путь к датасорсы
            normalization:
              Строка полей необходимые для корректной обработки шаблонизатором и если их нет в объекта
              то они будут созданы с пустыми значениями: "customField1,customField2"
       */
        // eslint-disable-next-line
        valueTemplate: '${data.value.length > 0 ? "(" + data.value.map(value => `${data.field} == ${isNaN(Number(value)) ? `"${value}"` : value}`).join(\' || \') + ")" : ""}',
        value: '',
        normalization: '',
        dataSource: null,

        placeholder: this.L10n('select'),
        placeholderAllSelected: this.L10n('select-all'),
        classes: '',
        styles: { minWidth: '30rem' },
        size: '',

        option: {
          label: 'title',
          value: 'id',
          template: null
        }
      }
    },
    handlerInput (e) {
      this.debounceHandlerFilter(e.target.value)
    },
    parseConfig (Options) {
      this.handle('parseStart')
      // reset data
      this.options = null
      this.model = []
      this.source = []
      // update options
      this.options = this.$_.merge(this.MODEL(), this.config.options, Options || {});
      ['placeholder', 'placeholderAllSelected', 'dataSource'].forEach(key => {
        this.options[key] = this.checkEs6AndRun(this.options[key])
      })
      this.parseOptionsTemplate()
      // TODO: NEED STRONG APPLY DATA SOURCE OPTION, BECAUSE ARRAY(S) is MERGED
      if (Options && Options.dataSource) {
        if (typeof Options.dataSource === 'object') {
          this.options.dataSource = this.$_.merge({}, Options.dataSource)
        } else if (Array.isArray(Options.dataSource)) {
          this.options.dataSource = [...Options.dataSource]
        } else {
          this.options.dataSource = Options.dataSource
        }
      }
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      // start update dataSource
      // TODO: NOTE#2 In next version need add multiple parse dataSource
      this.updateRendered()
      this.isLoading = false
      // Load data
      this.debounceHandlerFilter()
      this.handle('init')
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model.length) {
        this.result = this.valueTemplate({ field: this.config.field, value: this.model }, this)
        this.resultHuman = this.model
      } else if (this.model.length === 0) {
        this.result = this.valueTemplate({ field: this.config.field, value: [] }, this)
        this.resultHuman = null
      } else {
        this.result = this.valueTemplate({ field: this.config.field, value: ['null'] }, this)
        this.resultHuman = null
      }
    },
    createSource (filterValue) {
      let dataSource = this.options.dataSource
      if (dataSource && typeof dataSource === 'object') {
        this.isLoading = true
        let params = this.parseParams(filterValue)
        api.get(`${dataSource.url}`, { params })
          .then((response) => {
            this.handlerDataSourceResponse(response.data.value)
            this.isLoading = false
          })
      }
    },
    // parses
    parseSource (Items) {
      // set model
      this.source = [...Items]
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      // if (this.source.length) this.setValue(this.options.value, true)
      this.updateRendered()
      this.isLoading = false
      this.handle('init')
    },
    parseParams (filterValue) {
      let sourceConfig = this.options.dataSource
      let filter = (sourceConfig.filter)
        ? `${sourceConfig.filter} || ${this.options.option.label}.StartsWith(${filterValue})`
        : filterValue
          ? `${this.options.option.label}.StartsWith("${filterValue}")`
          : ''
      return {
        'select': sourceConfig.selected || '',
        'filter': filter || '',
        'take': sourceConfig.take || 50
      }
    },
    // HANDLERS
    handlerDataSourceResponse (Items) {
      // Response
      let items = [...Items]
      // Selected Items
      let selectedDataSource = this.model.map(id => this.mapDataSource[id])
      // Filter Selected items into response
      let filteredItems = items
        .filter(item => !selectedDataSource
          .some((selected) => selected[this.options.option.value] === item[this.options.option.value]))
      this.source = selectedDataSource.concat(filteredItems)
    },
    handleChange () {
      this.updateRendered()
      this.handle('change')
    },
    handleReset () {
      this.model = []
      this.handleChange()
    },
    handleClear () {
      this.model = []
      this.handleChange()
    },
    /**
     * @name resetField
     * @desc Method for reset field data. It emits, when user click button 'clear-filter'
     */
    resetField () {
      this.model = []
      this.updateRendered()
      this.handle('resetField')
    },
    handle (Type) {
      this.$emit('handle', {
        id: this.config.id,
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    }
  }
}
</script>

<style lang="stylus">
  .grid-filter.multi-select {
    position relative

    .all-placeholder {
      display none
      pointer-events none
      position absolute
      z-index 2
      line-height 3.5rem
      padding-left .6rem
    }
    &.is-all {
      .all-placeholder {
        display block
      }
      .el-select {
        .el-icon-arrow-up,
        .el-icon-arrow-down {
          display block !important
        }
        .el-icon-circle-close {
          display none !important
        }
      }

      .el-select {
        .el-select__tags span {
          display none
        }
      }
    }
  }
  .select-all {
    padding 0 20px
    border-bottom 1px solid #e7e7e9
  }
  .el-select-dropdown {
    .option-check-box-select__label{
      display flex
      align-items center
      &::before{
        content ''
        display inline-block
        width 1.8rem
        height 1.8rem
        border 1px solid #DCDFE6
        border-radius 2px
        margin-right 1rem
      }
    }
    .selected {

    }
  }
  .filter-multiselect-dropdown {
    .el-checkbox__input{
      &.is-checked{
        +.el-checkbox__label{
          font-weight 400
        }
      }
    }
  }
</style>
